<template>
  <div class="wrapper">
    <header>
      <img src="../assets/banner5.png" alt="">
    </header>
    <div class="wrap">
      <div class="headline">
        <h1>公司简介</h1>
        <span>About Us</span>
      </div>
      <dl class="aboutUs">
        <dt>
          <img src="../assets/企业办公室样机.png" alt="速派快递Fastgo" title="速派快递Fastgo">
        </dt>
        <dd>
          <p>Fastgo速派快递，是专为国际电子商务提供物流解决方案的集团型企业。为跨境电商、电商平台、外贸进出口商家和广大海淘用户，提供海外仓储、急货转运、保税备货、VMI库存管理、跨境干线运输、
            进出口通关、全球落地配送、退换货管理、采购、支付物流等。一系列综合服务的跨境物流运营平台。
          </p>
          <p>在中国、澳大利亚、加拿大、新西兰、日本、美国、香港等国家和地区提供网络性的快递物流服务。更多网点还在增加中。</p>
        </dd>
      </dl>
      <div class="headline">
        <p>我们的使命</p>
        <span>Our Mission</span>
      </div>
      <div class="headCont">
        我们设计、实施并执行创新的国际快递解决方案，为客户创造更大的价值，满足客户需求。
      </div>
      <div class="headline">
        <p>我们的愿景</p>
        <span>Our Vision</span>
      </div>
      <div class="headCont">
        用心做事，诚信为人。人才为本，绩效至上。矢志进取，自强不息。一工作品质提升企业价值，做务实、诚信、创新的现代物流服务业。一客户至上为服务理念，以科技创新为支撑点，立志成为整体物流解决方案、供应链物流系统解决方案的供应商和服务商。
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    metaInfo: {
      title: 'Fastgo', // set a title
      meta: [
        {                 // set meta
          name: 'keyWords',
          content: '速派快递，电商仓配，集运转运，快件进口和BC直购'
        }
      ]
    },
    name: 'AboutUs',
  }
</script>
<style scoped lang="scss">
  .wrapper {
    padding-bottom: 75px;
  }

  .wrap {
    width: 1000px;
    margin: 0 auto;
  }

  .headline {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 150px;
    h1 {
      font-weight: 600px;
      font-size: 30px;
      letter-spacing: 4px;
      line-height: 50px;
    }
    span {
      font-size: 20px;
      letter-spacing: 2px;
      color: #666;
    }
  }

  .headline:nth-child(3), .headline:nth-child(5) {
    align-items: flex-start;
    border-top: 1px solid #ccc;
  }

  .headCont {
    font-size: 17px;
    letter-spacing: 2px;
    line-height: 30px;
    min-height: 100px;
    color: #666;
  }

  .aboutUs {
    display: flex;
    height: 320px;
    margin-bottom: 50px;
    dt {
      width: 570px;
      img {
        height: 100%;
      }
    }
    dd {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 10px 0;
      box-sizing: border-box;
      padding-left: 10px;
      p {
        line-height: 25px;
        font-size: 15px;
        color: #5b5a5a;
        letter-spacing: 2px;
        text-indent: 30px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/AboutUs.vue